import { render, staticRenderFns } from "./CustomTool.vue?vue&type=template&id=51d15d1d"
import script from "./CustomTool.vue?vue&type=script&lang=ts"
export * from "./CustomTool.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./CustomTool.vue?vue&type=style&index=0&id=51d15d1d&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports